import { render } from "./FruitsByClassification.vue?vue&type=template&id=41ad287f"
import script from "./FruitsByClassification.vue?vue&type=script&lang=js"
export * from "./FruitsByClassification.vue?vue&type=script&lang=js"

import "./FruitsByClassification.vue?vue&type=style&index=0&id=41ad287f&lang=scss"
script.render = render

export default script